import { Truck, MessageCircle, Shield, Headphones } from 'lucide-react';
import { FREE_SHIPPING_THRESHOLD, RETURN_DAYS, formatTl } from '../constants/storePolicies';

const features = [
  {
    icon: Truck,
    title: 'Ücretsiz Kargo',
    description: `${formatTl(FREE_SHIPPING_THRESHOLD)} TL ve üzeri alışverişlerde`,
  },
  {
    icon: MessageCircle,
    title: 'WhatsApp Sipariş',
    description: 'Havale/EFT ile güvenli ödeme',
  },
  {
    icon: Shield,
    title: 'Kolay İade',
    description: `${RETURN_DAYS} gün içinde cayma hakkı`,
  },
  {
    icon: Headphones,
    title: '7/24 Destek Botu',
    description: 'WhatsApp & Instagram SSS asistanı',
  },
];

export function FeaturesSection() {
  return (
    <section className="bg-pink-50 py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center size-16 bg-pink-600 text-white rounded-full mb-4">
                  <Icon className="size-8" />
                </div>
                <h3 className="font-semibold mb-1 text-gray-900">{feature.title}</h3>
                <p className="text-sm text-gray-600">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
